import React from 'react';
import { getMeetingStatusColor, getStatusColor } from '../history.service';
import { activityTypes } from '../../../../helper/constants.helper';

const ClientIcon = ({ status, clientEmail, type }) => {
  return (
    <div
      className="icon flex-container justify-center align-center"
      style={{
        backgroundColor:
          type === activityTypes.MEETING ? getMeetingStatusColor(status) : getStatusColor(status)
      }}>
      {clientEmail?.charAt(0).toUpperCase()}
      <style jsx>
        {`
          .icon {
            background-color: var(--primary-color);
            color: white;
            fontSize: '24px'
            padding: 10px;
            width:30px;
            height:30px;
            border-radius: 50%;
          }
        `}
      </style>
    </div>
  );
};

export default ClientIcon;
